

import React from "react";
import SidebarItem from "./data/SidebarItem";
import { SidebarData } from "./data/SidebarData";
import kvsLogo from "../../assets/loginLogo.png"


export default function Sidebar() {
  return (
    // <aside className="w-64 bg-kvs  overflow-y-auto">
    <aside className=" fixed left-0 top-0 h-full w-64 bg-kvs overflow-y-auto">
      <div className="py-4 px-3">
        <div className="text-center text-white pt-6 mb-6">
      <img
        src={kvsLogo}
        alt="KVS Logo"
        className="mx-auto mb-2"
      />
      <p className="font-bold text-sm">Kendriya Vidyalaya Sangathan</p>
    </div>
        <nav aria-label="Main Navigation" className="space-y-1">
          {SidebarData.map((item) => (
            <SidebarItem key={item.id ?? item.label} item={item} level={0} />
          ))}
        </nav>
      </div>
    </aside>
  );
}






